/* eslint-disable @typescript-eslint/consistent-type-definitions -- we need to use `interface` in order to override MUIs interfaces*/
import '@hg-akademie-ban/ban-ui-lib/fonts.css';
import { createBanElevateTheme } from '@hg-akademie-ban/ban-ui-lib';

import { colorPalette, elevateColorPalette } from './colorPalette';

// TODO ban-ui-lib: some of the values here can be implemented in ban-ui-lib and then be removed here
export const theme = createBanElevateTheme({
  themeOverrides: {
    spacing: 8,
    palette: colorPalette,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              boxShadow: 'none',
            },
          },
        },
        variants: [
          {
            props: { variant: 'menu' },
            style: {
              borderRadius: '8px',
              '&:hover': {
                color: elevateColorPalette.text.brand,
                backgroundColor: elevateColorPalette.surface.brandLight,
              },
              justifyContent: 'flex-start',
              padding: '10px 12px',
              fontSize: '14px',
            },
          },
        ],
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: elevateColorPalette.text.primary,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            border: `1px solid ${elevateColorPalette.border.default}`,
            backgroundColor: elevateColorPalette.surface.background,
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          content: {
            fontFamily: 'TWK Haufe Akademie Everett, Arial',
          },
          expandIconWrapper: {
            color: elevateColorPalette.text.brand,
          },
        },
      },
    },
  },
});

// TODO ban-ui-lib: delete the following once ban-ui-lib provides it
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    headingXxl: true;
    headingXl: true;
    headingLg: true;
    headingMd: true;
    headingSm: true;
    headingXs: true;
    headingXxs: true;
    paragraphXl: true;
    paragraphLg: true;
    paragraph: true;
    paragraphSm: true;
    labelLg: true;
    labelLgLight: true;
    labelLgMultiline: true;
    labelLgMultilineLight: true;
    label: true;
    labelLight: true;
    labelMultiline: true;
    labelMultilineLight: true;
    labelSm: true;
    labelSmLight: true;
    h1?: false;
    h2?: false;
    h3?: false;
    h4?: false;
    h5?: false;
    h6?: false;
    subtitle1?: false;
    subtitle2?: false;
    body1?: false;
    body2?: false;
    button?: false;
    caption?: false;
    overline?: false;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    menu: true;
  }
}
